import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importEditDefaultAddressContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "EditDefaultAddressContainer" */
                '@perpay-web/fintech/components/containers/EditDefaultAddressContainer'
            ),
    );
